<template>
  <v-app>
    <Navigation />
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation";

export default {
  name: "App",
  components: {
    Navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
.loader {
  border: 4px solid #ffffff;
  border-top: 4px solid #2196f3;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 2s linear infinite;
}
.hide {
  display: none;
}
.v-snack {
  z-index: 100001;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
